module.exports = __webpack_public_path__ + "static/img/Q_hearts.2dba4be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/Q_hearts.svg
// module id = Ps/C
// module chunks = 1